import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import Paginate from 'vuejs-paginate'
import {
	Validator
} from 'vee-validate'
import Loader from './../shared/loader'
import Pagination from './../shared/pagination'
import Vue from "vue";
import JsonExcel from "vue-json-excel";
import download from 'downloadjs';
import csvHelper from '../reports/importjsontocsv';
import packingApis from '../../../views/components/packingnew/packingapis.js'
Vue.component("downloadExcel", JsonExcel);
import moment from 'moment';
export default {
	name: 'Boxtype',
	components: {
		Paginate,
		Loader,
		Pagination,
		JsonExcel,
		download,
	},

	data: function() {
		return {
			totalPage: 0,
			totalRows: 0,
			currentPage: 1,
			pageLimit: 10,
			// currentPage: 0,
			listBoxtypeData: [],
			listboxdata: [],
			addboxemodal: false,
			id: '',
			boxtype: '',
			searchboxtype: '',
			length: '',
			breadth: '',
			height: '',
			boxcreate: '',
			quantity: '',
			isLoading: false,
			resultCount: '',
			userid: '',
			clientsearch: '',
			boxtypesearch: '',
			warehousesearch: '',
			boxid:'',

			listClientData: [],
			listWarehouseData: [],
			// pageno: 0,
			// pageCount: 0,
			// pageLimit: 10,
			client: '',
			clientid: '',
			warehouse: '',
			warehouseid: '',
			showSelectClient: false,
			showSelectWarehouse: false,
			ClientErr: '',
			WarehouseErr: '',
			boxcondition:'',
			listBoxCondition:['Utilized','Not Utilized'],
			orderid:'',
			show:'',
			limitExeed:'',
			download: true,
			listReportDataforxls: [],
			csvFieldsForXls: {},
			reportname: '',
			packingbox:false,
			boxids: [],
			checkallflag: true,
			selectAll: false,
			token: '',
			channellist : [],
			searchchannel1:''
		}
	},

	created: function() {},
	// when a page loads,mounted() will be call
	filters: {
		moment: function(dates) {
			return moment(dates).format('DD-MM-YYYY HH:mm:ss');
		}
	},
	mounted() {
		var permissionEncrypt = window.localStorage.getItem('userdetail');
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.userid = userdetail.userid;
		var userToken = window.localStorage.getItem('userToken')
		this.token = userToken.replace(/"/g, '')
		this.pageno = 0;

		this.reportname = this.$t('activities.boxTypeReport')
		this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		this.user_type = userdetail.utype;
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		if (localStorage.getItem("selectedClient")!=='undefined')
		{
		this.getSalesChannels();
		this.getBoxtypeData();
		this.getPackingBox();
		}
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				// this.getClientList();
				//this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				// this.getWarehouseList();
				if (localStorage.getItem("selectedWarehouse")!=='undefined' && localStorage.getItem("selectedClient")!=='undefined')
				{
				this.getboxdata();
				}
				this.showSelectWarehouse = true;
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				// this.getClientList();

				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}

	},
	methods: {
		startDownload() {
			this.isLoadingforxls = true;
		},
		finishDownload() {
			this.isLoadingforxls = false;
		},
		resetAll: function (myAction) {
			if (myAction == 1) {
				this.boxids = [];
				this.selectAll = false;
			} else { }
		},
		tabChanged(obj) {
			this.resetFormData()
			if (obj == 1) {
				this.packingbox = false;
				this.getBoxtypeData()
			} else {
				this.packingbox = true;
				this.getPackingBox()
			}
		},
		selectAllCheckbox: function () {
			if (this.checkallflag == true) {
				//this.rackIds = [];
				if (this.selectAll) {
					for (let boxid in this.listboxdata) {
						if (this.boxids.indexOf(this.listboxdata[boxid].boxid) == -1)
							this.boxids.push(this.listboxdata[boxid].boxid);
					}
				} else {
					for (let boxid in this.listboxdata) {
						if (this.boxids.indexOf(this.listboxdata[boxid].boxid) >= 0)
							this.boxids.splice(this.boxids.indexOf(this.listboxdata[boxid].boxid), 1);
					}
				}
			} else {
				this.$alertify.error("Select All Is Disabled As, You Cannot Pick All Orders");
			}
		},
		Choosetype() {
			this.show = true;
			this.download = false;
			if (!this.limitExeed ) {
				this.getAuditListForXLS(3)
			}
		},
		getAuditListForXLS(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var dataFilter = {};
			this.show = true;
			this.download = false;
			this.dataFilter2 = [];
			var value = '';
			var str = '';
			let url= 'getboxlist';

			this.input = ({

				'clientid': this.client,
				'boxtype': this.boxtypesearch,
				'warehouseid': window.localStorage.getItem("selectedWarehouse"),
				'offset': (this.currentPage - 1) * 10,
				'limit': this.pageLimit,
				'boxcon': this.boxcondition,
				'order_id':this.orderid,
				'userid':this.userid,
				'boxid':this.boxid,
				csvData: csvCheck,
			});
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					value += k + ':' + v + ','
					this.dataFilter2 = str.concat(value);

				}
			})
			if(this.packingbox){
				delete this.input.userid;
				url = 'getb2bpackingboxlist';
			}
			axios({
					method: 'POST',
					'url': apiUrl.api_url + url,
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (csvCheck == 3) {
						if (result.data.data.count || result.data.count) {
							this.listReportDataforxls = [];
							this.csvFieldsForXls[this.$t('common.boxId')]='boxid',
							this.csvFieldsForXls[this.$t('boxList.boxType')]='boxtype',
							this.csvFieldsForXls[this.$t('boxList.length')]='length',
							this.csvFieldsForXls[this.$t('boxList.width')]='width',
							this.csvFieldsForXls[this.$t('boxList.height')]='height',
							this.csvFieldsForXls[this.$t('boxList.boxBatchId')]='boxbatchid',
							this.csvFieldsForXls[this.$t('common.warehouseID')]='warehouseid',
							this.csvFieldsForXls[this.$t('srReport.orderId')]='order_id',
							this.csvFieldsForXls[this.$t('boxList.shipmentId')]='shipment_id'

							if(this.packingbox){
							  this.csvFieldsForXls[this.$t('common.quantity')]='qty'
							  delete this.csvFieldsForXls['Box Batch Id']
							}

							this.listReportDataforxls = result.data.data.rows;
							if(this.packingbox){
								this.listReportDataforxls = result.data.data;
							}
						} else {
							if (result.data.status == true) {
								this.$alertify.success(this.$t('common.reportSizeError'));
							} else {
								this.$alertify.error(result.data.msg.message);
							}
						}
					}

				}, error => {
					console.error(error);
				})
		},


		////////
		// getWarehouseList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {

		// 		var userToken = window.localStorage.getItem('userToken')
		// 		var myStr = userToken.replace(/"/g, '');

		// 		this.input = ({
		// 			'clientid': this.clientid,
		// 		});

		// 		axios({
		// 				method: 'POST',
		// 				'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 				'data': this.input,
		// 				headers: {
		// 					'Authorization': 'Bearer ' + myStr
		// 				}
		// 			})
		// 			.then(result => {
		// 				this.listWarehouseData = result.data.data;
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },

		// getClientList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {

		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');

		// 		this.input = ({
		// 			'warehouseid': this.warehouseid,
		// 		});

		// 		axios({
		// 				method: 'POST',
		// 				'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 				'data': this.input,
		// 				headers: {
		// 					'Authorization': 'Bearer ' + myStr,
		// 				}
		// 			})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },

		// clientSelected(type) {
		// 	this.warehousesearch = '';
		// 	if (type == 'list') {
		// 		this.clientid = this.clientsearch;
		// 		if (this.clientid) {
		// 			this.getSalesChannels();
		// 			if (!this.warehouseid) {
		// 				this.getWarehouseList();
		// 			}
		// 			else {
		// 				if(!this.packingbox){
		// 					this.getBoxtypeData();
		// 				}else{
		// 					this.getPackingBox();
		// 				}
		// 				// this.getboxdata();
		// 			}
		// 		}
		// 	} else {
		// 		this.clientid = this.client;
		// 		this.getSalesChannels();
		// 			this.getWarehouseList();
		// 		    if(!this.packingbox){
		// 				this.getBoxtypeData();
		// 			}else if(this.warehouseid){
		// 					this.getPackingBox();
		// 			}
		// 	}
		// },

		// warehouseSelected(type) {
		// 	if (type == 'list') {
		// 		this.warehouseid = this.warehousesearch;
		// 		if (this.warehouseid) {
		// 			if (!this.clientid) {
		// 				this.getClientList();
		// 			}
		// 			else if(this.packingbox){
		// 				this.getPackingBox();
		// 			}
		// 			 else {
		// 				this.getBoxtypeData();
		// 				// this.getboxdata();
		// 			}
		// 		}
		// 	} else {
		// 		this.warehouseid = this.warehouse;
		// 		console.log("---------373-----");
		// 		if(!this.packingbox){
		// 			this.getBoxtypeData();
		// 		}
		// 		else{
		// 			this.getPackingBox();
		// 		}
		// 	}
		// },

		addNewBox() {
			document.getElementById("quantity").value = '';
			this.boxcreate = "add";
			this.addboxemodal = true;
			this.boxtype = '';
			this.quantity = '';
			this.client = '';
			this.warehouse = '';
			this.$validator.reset();
			this.errors.clear();

		},

		closeaddboxemodal() {
			document.getElementById("quantity").value = '';
			this.addboxemodal = false;
			this.quantity = '';
			this.boxtype = '';
			// this.client = '';
			this.warehouse = '';
			this.$validator.reset();
			this.errors.clear();

		},

		// this function for pagination
		getBoxtypeData() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			this.input = {
				clientid: localStorage.getItem("selectedClient"),
			};

			if (localStorage.getItem("selectedClient")) {
				// this.isLoading = true;
				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'boxtypelist',
						'data': this.input,
						headers: {
							'Authorization': 'Bearer ' + myStr
						}
					})
					.then(result => {
						this.listBoxtypeData = result.data.rows;
						this.isLoading = false;
					}, error => {
						console.error(error);
					})
			} else {
				this.listBoxtypeData = [];
				//	this.ClientErr = 'Client is required';
			}
			console.log(this.listBoxtypeData)
		},

		// This function for get box list
		getboxdata(csvCheck=0) {
			if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				return false;
			}

			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				return false;
			}
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			let url= 'getboxlist';

			var dataFilter = {};
			if (csvCheck == 2) {
				this.show = false;
				this.download = true;
				this.currentPage=1;
			}
			if(this.boxcondition!='Utilized'){
				this.orderid='';
			}
			if (window.localStorage.getItem("selectedClient") == '') {
				console.log('c');
				this.ClientErr = this.$t('common.clientError');
				this.pageno = this.pageCount = 0;
				this.listboxdata = [];
				return false;
			}
			if (window.localStorage.getItem("selectedWarehouse") == '') {
				console.log('w');
				this.WarehouseErr = this.$t('common.warehouseError');
				this.pageno = this.pageCount = 0;
				this.listboxdata = [];
				return false;
			}
			this.input = ({
				'clientid': window.localStorage.getItem("selectedClient"),
				'boxtype': this.boxtypesearch,
				'warehouseid': window.localStorage.getItem("selectedWarehouse"),
				'offset': (this.currentPage - 1) * 10,
				'limit': this.pageLimit,
				'boxcon': this.boxcondition,
				'csvData': csvCheck,
				'userid':this.userid,
				'order_id': this.orderid,
				'boxid':this.boxid,

			});
			if(this.packingbox){
				delete this.input.userid;
				url = 'getb2bpackingboxlist';
			}
			console.log(this.input)
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})
			if (window.localStorage.getItem("selectedClient") && window.localStorage.getItem("selectedWarehouse")) {
				this.isLoading = true;
				axios({
						method: 'POST',
						'url': apiUrl.api_url + url,
						'data': this.input,
						headers: {
							'Authorization': 'Bearer ' + myStr
						}
					})
					.then(result => {
						if (csvCheck == 1) {
							if(result.data.data.count < 10000 || result.data.count < 10000){
							this.show = true;
							this.download = false;
							this.listAuditDatacsv = [];
							this.csvFields = {
								 'boxid':this.$t('common.boxId'),
								'boxtype':	this.$t('boxList.boxType'),
								 'length':this.$t('boxList.length'),
								 'width':this.$t('boxList.width'),
								 'height':	this.$t('boxList.height'),
								 'qty':this.$t('common.quantity'),
								 'warehouseid':this.$t('common.warehouseID'),
								 'order_id':this.$t('srReport.orderId'),
								 'shipment_id':	this.$t('boxList.shipmentId'),
								 'boxbatchid' : this.$t('boxList.boxBatchId')
							};

							var dateFilter = ['starttime', 'endtime'];
							var skipFilter = ['sessionid','merchantid'];
							this.listAuditDatacsv = [];
							this.listAuditDatacsv1=[]
							if(!this.packingbox)
							this.listAuditDatacsv = result.data.data.rows;
							else if(this.packingbox ){
								this.listAuditDatacsv = result.data.data;
								this.listAuditDatacsv = result.data.data.filter(function (el) { return delete el.boxstatus, delete el.count, delete el.created_by, delete el.created_date, delete el.modified_by, delete el.modified_date, delete el.tareweight,delete el.weight,delete el.weightcapacity});
							}

							csvHelper.data.jsonToCSV(this.$t('activities.boxTypeReport'), this.listAuditDatacsv, this.csvFields, dateFilter, skipFilter, dataFilter);
							this.isLoading = false;
			             	}else{
								this.isLoading = false;
								this.$alertify.success(this.$t('common.reportSizeError'));
							}
						}else{

							if (!this.packingbox) {
								this.listboxdata = result.data.data.rows;
								this.resultCount = result.data.data.count;
								this.totalRows = result.data.data.count;
								this.setPageCounts(result.data.data.count);
								this.isLoading = false;
							} else {
								this.listboxdata = result.data.data;
								this.resultCount = result.data.data.length > 0 ? result.data.data[0].count : 0;
								this.totalRows = result.data.data.length > 0 ? result.data.data[0].count : 0;
								this.setPageCounts(this.resultCount);
								this.isLoading = false;
							}
						}
						//console.log(this.listboxdata.length)
					}, error => {
						console.error(error);
					})
			} else {
				this.listboxdata = [];
				this.resultCount = 0;
				this.setPageCounts(0);

				if (!this.clientid) {
					this.ClientErr = this.$t('common.clientError');
				}
				if (!this.warehouseid) {
					this.ClientErr = this.$t('common.warehouseError');
				}
			}
		},

		savebox() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			if (this.boxtype == '' || window.localStorage.getItem("selectedClient") == '' || this.quantity == '' || window.localStorage.getItem("selectedWarehouse")=='') {
				console.log(window.localStorage.getItem("selectedClient"))
				return false;
			}
			if (this.quantity <= 0) {
				this.quantity = '';
				this.$alertify.error(this.$t('boxList.qtygreaterthan0'));
				return false;
			}
			let createBoxPayload = {
				boxtype: this.boxtype,
				quantity: this.quantity,
				clientid: window.localStorage.getItem("selectedClient"),
				warehouseid: window.localStorage.getItem("selectedWarehouse"),
				userid: this.userid,
			}
			let saveboxurl = "savebox";
			if(this.packingbox){
				 saveboxurl = "saveb2bpackingboxseries";
				delete createBoxPayload.userid
				createBoxPayload.useremail = this.loginUserEmail
			}
			this.isLoading = true;
			axios({
					method: "POST",
					url: apiUrl.api_url + saveboxurl,
					data: createBoxPayload,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(response => {
					if (!this.packingbox && response.data.errorCode == 0) {
						this.isLoading = false;
						this.client = '';
						axios({
							method: "POST",
							'url': 'http://localhost:7500/api/printer/printboxbarcode',
							data: {
								formaData: response.data.boxdata.rows
							},
							headers: {
								'Authorization': 'Bearer ' + myStr
							}
						}).then(response => {
							console.log(responlistBoxtypeDatase);
						})

						this.$alertify.success(response.data.msg);
						this.addboxemodal = false;

					} else if(this.packingbox && response.data.ErrorCode ==0){
						this.$alertify.success(response.data.msg);
						this.addboxemodal = false;
						this.isLoading = false;
						this.clientsearch = this.client
						this.getboxdata(2);
					}
					 else if (response.data.msg == -1) {
						this.$alertify.success(response.data.msg);
						this.addboxemodal = false;
					}

				})
				.catch(httpException => {
					console.error("exception is:::::::::", httpException);
				});
		},
		async getPackingBox(){
			if(this.packingbox){
			let inputPayload = {
				clientid: localStorage.getItem("selectedClient"),
				warehouseid: localStorage.getItem("selectedWarehouse"),
				salesChannel:this.searchchannel1
			}
				let response = await packingApis.getPackingBox(inputPayload, this.token)
				if (response.data.errorcode == 0) {
					this.listBoxtypeData = response.data.data;
					console.log(this.listBoxtypeData,"========this.listBoxtypeData===");
				}
			}
		},
		printBoxsticker(){
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			const printBoxPayload = {
				boxid:this.boxids
			}
			axios({
				method: "POST",
				url: apiUrl.api_url + "generateBarcode",
				data: printBoxPayload,
				headers: {
					'Authorization': 'Bearer ' + myStr
				},
				responseType:"blob"
			}).then(result => {
			  const file = new Blob([result.data], { type: "application/pdf" });
			  //Build a URL from the file
			  const fileURL = URL.createObjectURL(file);
			  //Open the URL on new Window
			   const pdfWindow = window.open();
			   pdfWindow.location.href = fileURL;
			})
		},
		onPageChange(page) {
			this.currentPage = page;
			this.getboxdata()
		},

		//Sets total number of pages
		setPageCounts(total_rows) {
			if (total_rows > 0) {
				if (total_rows <= this.pageLimit) {
					this.totalPage = 1;
				} else {
					this.totalPage = Math.ceil(total_rows / this.pageLimit);
				}
			} else {
				this.totalPage = 0;
			}
		},
		getSalesChannels() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');

			if (this.clientid == '') {
				this.WarehouseErr = this.$t('srReport.clientError');
				return false;
			}
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'orderSalesChannelList',
					'data': {
						clientid: this.clientid
					},
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					this.listBoxtypeData = [];
					this.channellist = result.data.data;
					this.getPackingBox();
				}, error => {
					console.error(error);
				});
		},

		resetFormData() {
			this.orderid='';
			this.id = '';
			this.boxcondition='';
			this.searchboxtype = '';
			this.boxtypesearch = '';
			this.boxid='';
			this.totalRows = 0;
			this.clientsearch = '';
			this.warehousesearch = '';
			this.totalPage = 0;
			// this.listBoxtypeData = [];
			this.listboxdata = [];
			this.resultCount = 0;
			this.ClientErr = "";
			this.WarehouseErr = "";
			this.searchchannel1='';
			// this.channellist = [];
			if (this.user_type == 'warehouse_user') {
				this.clientid = '';
			} else if (this.user_type == 'client_user') {
				this.warehouseid = '';
			} else {
				this.clientid = '';
				this.warehouse = '';
				this.warehouseid = '';
			}
		},

		onSubmit: function(e) {
			this.$validator
				.validateAll()
				.then((result) => {
					if (result) {
						console.log("form is valid", this.model);
						event.target.reset();
					} else {
						return false;
					}

				})
				.catch(() => {
					console.log("errors exist", this.errors);
				});
		}
	}
}



// WEBPACK FOOTER //
// ./src/views/components/boxtype/boxtype.component.js